import humps from "humps";

export function formatResponse(obj) {
  return humps.camelizeKeys(obj);
}
